import * as R from 'ramda';
export var RefundStatusText = {
  CHANGE: '退款异常',
  PROCESSING: '退款中',
  REFUNDCLOSE: '退款关闭',
  SUCCESS: '退款成功',
  TO_BE_REFUND: '待退款'
};
export function statusCodes() {
  return R.keys(RefundStatusText);
}
export function statusOptions() {
  return R.values(RefundStatusText);
}